import { useOrganization } from 'hooks/store';
import { useFeatureFlags } from 'utils/features/hooks';

export default function useEquipmentInspectionsEnabled() {
  const organization = useOrganization();
  return useFeatureFlags('EQUIPMENT_INSPECTIONS') && !!organization.equipmentInspections;
}
